export enum NotificationLevel {
  'ALL' = 'ALL',
  'REQUIRE_REVIEW_ONLY' = 'REQUIRE_REVIEW_ONLY',
}
